module.exports = new __parcel__URL__("empty-no-clock.09305c72.svg").toString();